import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { Pricing } from 'src/app/models/pricing.model';
import { PricingService } from 'src/app/services/pricing.service';

@Component({
    selector: 'app-pricing-modal',
    templateUrl: './pricing-modal.component.html',
    styleUrls: ['./pricing-modal.component.scss'],
    standalone: false
})
export class PricingModalComponent implements OnInit {

  models: Pricing[];
  constructor(
    public service: PricingService,
    public translateService: TranslateService,
    public toastr: ToastrService,
    private router: Router, public modal: NgbActiveModal,

  ) {
  }
  ngOnInit(): void {
    this.service.getAllPricingWithPlanDetail$().subscribe(x => {
      this.models = x;
    })
  }
  createImgPath = (serverPath: string) => {
    return this.service.createImgPath(serverPath);
  }
  isSaving: boolean;
  loading: boolean;
  selectPackage(referenceId: string) {
    this.isSaving = true;
    const sbCreate = this.service.selectPackage$(referenceId).pipe(
      tap(() => {
        this.isSaving = false;
      }),
      finalize(() => {
        this.loading = false;
        this.isSaving = false;

      })
    ).subscribe(content => {
      if (content) {

        this.isSaving = false;
        this.toastr.success("AddedSuccess");
        this.modal.close();
        this.router.navigate(['payment/pending-pakages']);
      }
    }, j => {
      return of();
    });
  }
}
